import React, { useEffect, useState } from "react";
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";
import { ComuneSelect } from "../components/ComuneSelect";
import { getProvinceCoperte } from "../lib/istat";
import api, { formatApiError } from "../lib/api";
import { toast, Toaster } from "sonner";

const IMG = "https://images.pexels.com/photos/8112186/pexels-photo-8112186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=940";

export default function LeadForm() {
  const [agencies, setAgencies] = useState([]);
  const [province, setProvince] = useState([]);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    nome: "", email: "", telefono: "", provincia: "Vicenza",
    comune: "", tipo_immobile: "Appartamento", agenzia_preferita_id: "", note: "",
  });

  useEffect(() => { api.get("/public/agencies").then((r) => setAgencies(r.data)); }, []);
  useEffect(() => { getProvinceCoperte().then(setProvince); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form };
      if (!payload.agenzia_preferita_id) delete payload.agenzia_preferita_id;
      await api.post("/leads", payload);
      setSent(true);
      toast.success("Richiesta inviata. Ti contatteremo presto.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="paper-bg" data-testid="lead-form-page">
      <Toaster position="top-right" richColors />
      <PublicNav />
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 pt-16 pb-24 grid md:grid-cols-12 gap-16">
        <div className="md:col-span-5">
          <div className="label-uppercase">Il tuo immobile</div>
          <h1 className="font-serif text-5xl md:text-6xl mt-3 leading-[0.95]">Scopri se la tua casa può entrare.</h1>
          <p className="text-[#5C5657] mt-6 leading-relaxed">
            Raccontaci in due minuti il tuo immobile. Se rientra nel perimetro del Protocollo, ti mettiamo in contatto con l'agenzia partner della tua zona.
          </p>
          <img src={IMG} alt="" className="w-full aspect-[5/4] object-cover mt-10 border border-[#E6E4E0]" />
        </div>

        <div className="md:col-span-7">
          {sent ? (
            <div className="border border-[#245A2E] bg-[#EBF4EC] p-10" data-testid="lead-success">
              <div className="label-uppercase text-[#245A2E]">Richiesta ricevuta</div>
              <h2 className="font-serif text-3xl mt-3">Grazie, ti richiamiamo noi.</h2>
              <p className="text-sm mt-4 text-[#3A3D42]">La richiesta è stata inoltrata all'agenzia partner della tua zona e allo staff di Pronto alla Vendita.</p>
              <button onClick={() => { setSent(false); setForm({ nome:"", email:"", telefono:"", provincia:"Vicenza", comune:"", tipo_immobile:"Appartamento", agenzia_preferita_id:"", note:"" }); }} className="btn-secondary mt-6">Invia un'altra richiesta</button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-8" data-testid="lead-form">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <label className="label-uppercase">Nome e cognome *</label>
                  <input required data-testid="lead-nome" value={form.nome} onChange={upd("nome")} className="editorial-input" />
                </div>
                <div>
                  <label className="label-uppercase">Email *</label>
                  <input required type="email" data-testid="lead-email" value={form.email} onChange={upd("email")} className="editorial-input" />
                </div>
                <div>
                  <label className="label-uppercase">Telefono *</label>
                  <input required data-testid="lead-telefono" value={form.telefono} onChange={upd("telefono")} className="editorial-input" />
                </div>
                <div>
                  <label className="label-uppercase">Provincia *</label>
                  <select
                    required
                    data-testid="lead-provincia"
                    value={form.provincia}
                    onChange={(e) => setForm({ ...form, provincia: e.target.value, comune: "" })}
                    className="editorial-input bg-transparent"
                  >
                    {province.map((p) => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div>
                  <label className="label-uppercase">Comune</label>
                  <ComuneSelect
                    value={form.comune}
                    onChange={(v) => setForm({ ...form, comune: v })}
                    provincia={form.provincia || null}
                    testid="lead-comune"
                    placeholder="Cerca il comune…"
                  />
                </div>
                <div>
                  <label className="label-uppercase">Tipologia immobile *</label>
                  <select required data-testid="lead-tipo" value={form.tipo_immobile} onChange={upd("tipo_immobile")} className="editorial-input bg-transparent">
                    {["Appartamento","Villa","Casa singola","Bifamiliare","Rustico","Altro"].map((t) => <option key={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className="label-uppercase">Agenzia preferita (opzionale)</label>
                <select data-testid="lead-agenzia" value={form.agenzia_preferita_id} onChange={upd("agenzia_preferita_id")} className="editorial-input bg-transparent">
                  <option value="">Nessuna preferenza</option>
                  {agencies.map((a) => <option key={a.id} value={a.id}>{a.name} — {a.comune}</option>)}
                </select>
              </div>
              <div>
                <label className="label-uppercase">Note</label>
                <textarea data-testid="lead-note" rows={4} value={form.note} onChange={upd("note")} className="editorial-input resize-none" />
              </div>
              <button type="submit" disabled={loading} data-testid="lead-submit" className="btn-primary">
                {loading ? "Invio in corso…" : "Invia richiesta"}
              </button>
              <p className="text-xs text-[#5C5657] mt-2">Compilando accetti l'informativa privacy. I dati sono trattati per finalità commerciali connesse al Protocollo.</p>
            </form>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
